import React, { useEffect, useState } from 'react'
import Leftimg from '../Components/Leftimg'
import { Box, useMediaQuery, useTheme } from '@mui/material'
import Styles from '../Config/Styles'
import { storage } from '../Config/Storage'
import Phonenumber from '../Components/Phonenumber'
import VerifyOtp from '../Components/VerifyOtp'
import ChooseType from '../Components/ChooseType'
import Toastify from '../Components/Toastify'
import Loader from '../Components/Loader'
import Mycart2 from '../Components/Mycart2'
import { useDispatch, useSelector } from 'react-redux'
import { getdraftOrders } from '../Redux/Mycart/action'

const Login = () => {
  const { orders } = useSelector((state) => state?.CartData) || [];
  const theme = useTheme()
  const dispatch = useDispatch()
  const [component, setComponent] = useState("phone")
  const [loader, setLoading] = useState(false)
  const rfq = storage.fetch.rfq()
  let width = orders?.length || rfq !== undefined ? "40%" : "70%"
  const isMobile = useMediaQuery(theme.breakpoints?.down("sm"));

  useEffect(() => {
    dispatch(getdraftOrders({ session: sessionStorage.getItem("session") }))
  }, [component])


  return (
    <Box sx={Styles.LoginStyle.box}>
      <Toastify />
      <Loader open={loader} />
      <Box
        sx={Styles.LoginStyle.leftbox}
      >
        <Leftimg />
      </Box>
      {component === "phone" ?
        <Phonenumber width={isMobile ? "100%" : width} setComponent={setComponent} setLoading={setLoading} />
        : component === "verify" ? <VerifyOtp width={isMobile ? "100%" : width} setComponent={setComponent} setLoading={setLoading} />
          : <ChooseType width={width} setComponent={setComponent} setLoading={setLoading} cart={orders?.length ? true : false} />
      }
      {width === "40%" && !isMobile ? <Mycart2 /> : null}
    </Box>
  )
}

export default Login